import * as React from "react";
import PresentationChatBot from "./PresentationChatBot";

const PresentationContainer: React.FC = () => {
  return (
    <div className="flex h-full min-h-0 flex-col text-gray-900">
      <PresentationChatBot />
    </div>
  );
};

export default PresentationContainer;
